module.exports = __webpack_public_path__ + "static/media/twin-towers_logo_black.3acccc66.svg";